import React from 'react';
import SecondPageHeader from '../../../components/ui/SecondPageHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadingCard } from '../../../components/ui/LoadingCard';
import { UploadedAttendanceStatementEditor } from '../../../components/attendance/reports/uploaded/UploadedAttendanceStatementEditor';
import { useSuIntl } from '../../../hooks/useSuIntl';

export const UploadedStatementReportScreen: React.FC = () => {
    const { t } = useSuIntl();
    const params = useParams<{ statementId: string }>();
    const navigate = useNavigate();

    if (!params.statementId) {
        return (
            <>
                <SecondPageHeader onBack={() => navigate(-1)} title={t('attendanceStatement.title.long.singular')} />
                <LoadingCard />
            </>
        );
    }

    return (
        <>
            <SecondPageHeader onBack={() => navigate(-1)} title={t('attendanceStatement.title.long.singular')} />
            <UploadedAttendanceStatementEditor reportId={+params.statementId} />
        </>
    );
};
